import { BoolFilter } from '@/@generated/codegen/API';

export const parseBooleanQueryParam = (value: string | undefined): BoolFilter | undefined => {
  if (!value) {
    return undefined;
  }

  const lowerCaseValue = value.toLowerCase();
  if (lowerCaseValue === 'true') {
    return {
      equals: true,
    };
  } else if (lowerCaseValue === 'false') {
    return {
      equals: false,
    };
  }

  return undefined;
};
